import { SliderMode as FluentSliderMode, SliderOrientation as FluentSliderOrientation, SliderSize as FluentSliderSize } from "@fluentui/web-components";
/** Selection mode values for {@link Slider}. */
export const SliderModes = {
    ...FluentSliderMode
};
/** Orientation values for {@link Slider}. */
export const SliderOrientations = {
    ...FluentSliderOrientation
};
/** Size values for {@link Slider}. */
export const SliderSizes = {
    ...FluentSliderSize
};
/** Event names for {@link Slider}. */
export const SliderEventNames = {
    change: "change"
};
//# sourceMappingURL=slider.options.js.map